/**
 * Resources script
 * 
 * @author HammersportMarketing
 */
 import "../../sass/resources.scss";
 import AWN from "awesome-notifications";

 $(".subscribe-form").on("submit", function(e){
   e.preventDefault();

   const form = $(this);

   const formData = {
      fileURL: form.attr("action"),
      email: form.find("input[name='email']").val(),
   }

   //Empty all errors lists container
   $("ul.error-list").empty();

   // Create new promise to handle notifications with awesome-notifications
   let promise = $.ajax({
       url: global_vars.ajaxurl,
       type: 'POST',
       data:{
           action: "hsm_send_resource",
           security: theme_vars.ajax_nonce,
           form: JSON.stringify(formData)
       }
   });
   // Handle response behavior with awesome-notifications
   let notifier = new AWN();
   notifier.asyncBlock(
      promise,
      // On success 
      function(response){
         const errors = response.data;

         // Check for errors
         if (errors.length  <= 0){
            // Handle ajax success
            notifier.success(`Check your email. We've successfully sent the resource.`);
         }else{
            notifier.alert("Woops, there's something wrong. Please check your info and try again");

            const errorsArr = Object.entries(errors)
            for(const[field,errors] of errorsArr){
                  for(const error of errors){
                     $(`ul.error-list[data-name="${field}"]`).removeClass('d-none');
                     $(`ul.error-list[data-name="${field}"]`).append(
                        `<li class="text-danger small">${error}</li>`
                        );
                     }
            }
         }
      },
      // On reject
      function(response){
         notifier.alert("Something went wrong, please try again later");
      }
   );


   // let htmlCaptcha = `
   //    <div class="d-flex align-items-center mb-4">
   //       <label class="g-recaptcha" name="g-recaptcha-response" data-sitekey="6LeqrDUbAAAAAJGkXs_gmiRrVD1Swnwn4NO7CD5L"></label>
   //       <div>
   //          <button class="btn btn-primary btn-submit res-submit">submit</button>
   //          <button class="btn btn-primary btn-submit res-submit-down">submit & download</button>
   //       </div>
   //    </div>
   // `

   // new AWN().modal(htmlCaptcha);

 });
